import React from 'react'
import PropTypes from 'prop-types'
import TimelineTable from './TimelineTable'
import Slider from 'react-rangeslider'
import Stepper from 'react-stepper-horizontal'
import 'react-rangeslider/lib/index.css'
import {Timeline, TimelineBlip} from 'react-event-timeline'
import {Glyphicon} from 'react-bootstrap'
import VideoModal from '../components/VideoModal'

class TimelineTool extends React.Component {
    render() {
        let stepCount = 0
        if(this.props.timelineRows){
            stepCount = this.props.timelineRows.length
        }

        var timelineBlips
        if(this.props.timelineRows){
            timelineBlips = this.props.timelineRows.map((event,index) => {
                if(this.props.activeStep===index){
                    return <TimelineBlip
                                title={event.title}
                                icon={<Glyphicon style={{paddingLeft:2+'px'}} glyph='hand-right'/>}
                                iconColor={this.props.activeBlipColor}
                                key={index}
                            />

                }else if(this.props.activeStep<index){
                    return <TimelineBlip
                                title={event.title}
//                                icon={<Glyphicon style={{paddingLeft:2+'px'}} glyph='unchecked'/>}
                                iconColor='#D1D2D4'
                                key={index}
                            />
                }else{
                    return <TimelineBlip
                                title={event.title}
                                icon={<Glyphicon style={{paddingLeft:2+'px'}} glyph='ok'/>}
                                iconColor='#D1D2D4'
                                key={index}
                            />
                }
            })
        }

        return (
        <div>
            {this.props.shouldShow &&
                <div>
                    <h3>Timeline
                        <VideoModal
                            videoTitle='Set a Timeline'
                            videoURL='https://www.youtube.com/watch?v=YJ8bcpsEdoo'
                        />
                    </h3>
                    <TimelineTable
                        dataRows={this.props.timelineRows}
                        deleteButtonText='Remove event(s)'
                        onAddRow={this.props.onAddRow}
                        onEditRow={this.props.onEditRow}
                        onDeleteRow={this.props.onDeleteRow}
                    />
                    {stepCount > 0 &&
                        <Slider
                            orientation='horizontal'
                            min={-1}
                            max={stepCount-1}
                            step={1}
                            value={this.props.activeStep}
                            tooltip={false}
                            onChange={this.props.onChangeCurrentTimelinePoint}
                        />
                    }
                </div>
            }
            {(stepCount > 0 && stepCount < 5) ? (
                <Stepper
                    circleFontSize={20}
                    steps={this.props.timelineRows}
                    activeStep={this.props.activeStep}
                    completeColor='#D1D2D4'
                    activeColor={this.props.activeCircleColor}
                    defaultColor='#EDEDED'
                    completeBarColor={this.props.completedBarColor}
                    completeTitleColor={this.props.completedColor}
                    activeTitleColor={this.props.stepperColor}
                />
            ):(
                <div>
                    {stepCount > 0 &&
                    <div>
                        {typeof timelineBlips !== 'undefined' &&
                           <Timeline>
                                {timelineBlips}
                            </Timeline>
                        }
                    </div>
                    }
                </div>
            )}
        </div>
        )
    }
}
TimelineTool.propTypes = {
    timelineRows: PropTypes.array,
    shouldShow: PropTypes.bool,
    stepperColor: PropTypes.string,
    completedColor: PropTypes.string,
    activeCircleColor: PropTypes.string,
    completedBarColor: PropTypes.string,
    activeBlipColor: PropTypes.string,
    activeStep: PropTypes.number,
    onChangeCurrentTimelinePoint: PropTypes.func.isRequired,
    onAddRow: PropTypes.func.isRequired,
    onEditRow: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
}

TimelineTool.defaultProps = {
    shouldShow: true,
    completedColor: '#757575',
    activeBlipColor: '#ED1558',
    activeCircleColor: '#ED1558',
    completedBarColor: '#757575',
    stepperColor: '#000000',
}

export default TimelineTool



// WEBPACK FOOTER //
// ./src/components/TimelineTool.js